import { getReadableValue, implementer } from "../../../helpers/selectOptions"

export const handler = tracker => ({
  startTrackingSession: (token, userRoles) => {
    const rolesInSpanish = userRoles.map(role => getReadableValue(implementer.profile.userRoles, role))

    const sessionData = {
      id: token.uid,
      email: token.email,
      fullName: token.name,
      userRoles: rolesInSpanish
    }
    tracker().initTrackingSession(sessionData)
  }
})

export default handler